import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
const TermsOfService = () => {
  return <div className="min-h-screen bg-black text-white flex flex-col">
      <SEO title="Terms of Service - Slay" description="Read our Terms of Service to understand the rules and regulations for using Slay's LGBTQIA+ event platform." />
      <Header />
      
      <main className="flex-grow pt-32 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-6xl font-bold bg-gradient-to-r from-[#9b87f5] to-[#D946EF] bg-clip-text text-transparent mb-6">
              Website Terms and Conditions
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">Effective Date: 22nd September 2025</p>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto mt-4">
              These Terms and Conditions govern your access to and use of Slay Events Australia's websites, applications, and services.
            </p>
          </div>

          <div className="bg-gradient-to-br from-purple-900/20 via-black/40 to-pink-900/20 backdrop-blur-lg border border-white/10 rounded-2xl p-8 md:p-12 space-y-8">
            
            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white border-b border-purple-500/30 pb-2">
                1. ABOUT US
              </h2>
              <p className="text-gray-300 leading-relaxed">
                Slay Events is operated by Slayverse Pty Ltd (ABN 85 629 390 414), trading as Slay Events Australia. Legal address: Level 7, 222 Exhibition Street, Melbourne VIC 3000, Australia. Contact: <a href="mailto:support@slay.events" className="text-purple-400 hover:text-purple-300">support@slay.events</a>.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white border-b border-purple-500/30 pb-2">
                2. DEFINITIONS
              </h2>
              <div className="text-gray-300 leading-relaxed space-y-3">
                <p><strong>"Platform"</strong> refers to our websites, mobile apps, APIs, ticketing infrastructure, and all associated digital products.</p>
                <p><strong>"Event Organiser"</strong> or <strong>"Producer"</strong> refers to users who create, manage, and list events.</p>
                <p><strong>"Attendee"</strong> or <strong>"Customer"</strong> refers to users who register for, buy tickets to, or otherwise interact with an event.</p>
                <p><strong>"Talent"</strong> refers to performers, DJs, drag artists, hosts, and contributors involved in events listed on Slay.</p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white border-b border-purple-500/30 pb-2">
                3. ACCOUNT REGISTRATION
              </h2>
              <p className="text-gray-300 leading-relaxed">
                You must register an account to use certain features. You:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Must be 18+ or have parental consent</li>
                <li>Agree to provide accurate information</li>
                <li>Are responsible for maintaining your account security</li>
                <li>Must not impersonate others or misrepresent your identity</li>
              </ul>
              <p className="text-gray-300 leading-relaxed mt-3">
                We may suspend or terminate accounts that violate our policies.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white border-b border-purple-500/30 pb-2">
                4. OUR ROLE
              </h2>
              <p className="text-gray-300 leading-relaxed">
                Slay acts as a technology provider and marketplace. Unless stated otherwise, Slay is <strong>not</strong> the host or operator of the event. Ticket sales, refunds, and event delivery are the sole responsibility of the Event Organiser.
              </p>
              <p className="text-gray-300 leading-relaxed mt-3">
                We provide tools for:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Ticketing and registration</li>
                <li>Marketing and promotion (e.g. Boost, SMS/email)</li>
                <li>Creator monetisation (e.g. tipping, donations)</li>
                <li>Content sharing (e.g. event flyers, videos)</li>
                <li>Community engagement (e.g. chat groups, SlayMeet)</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white border-b border-purple-500/30 pb-2">
                5. FEES AND PAYMENTS
              </h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold text-white mb-2">Organisers:</h3>
                  <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                    <li>Will pay service fees based on the pricing schedule in effect at the time</li>
                    <li>May opt for Slay as merchant of record or use a third-party gateway</li>
                    <li>Are responsible for refunding Attendees in the event of cancellation, postponement, or non-performance</li>
                  </ul>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white mb-2">Attendees:</h3>
                  <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                    <li>Understand that ticket sales are final unless an event is cancelled or significantly changed</li>
                    <li>Acknowledge that each event has its own refund policy set by the Organiser</li>
                    <li>Agree that <strong>Slay's platform fee and payment processing fee are non-refundable under all circumstances</strong></li>
                    <li>Agree not to initiate chargebacks for non-refundable fees or where refunds are governed by the organiser's terms</li>
                  </ul>
                </div>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white border-b border-purple-500/30 pb-2">
                6. TIPPING, DONATIONS AND MONETISATION
              </h2>
              <p className="text-gray-300 leading-relaxed">
                Slay enables creators and Organisers to receive voluntary tips or donations. You agree:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Tips are non-refundable unless the feature was abused or misused</li>
                <li>You are responsible for any tax or legal obligations arising from received amounts</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white border-b border-purple-500/30 pb-2">
                7. USER CONTENT & VIDEO UPLOADS
              </h2>
              <p className="text-gray-300 leading-relaxed">
                You may upload videos, images, bios, or event information. You grant Slay a worldwide, royalty-free licence to host, display, and promote this content across the platform and in marketing.
              </p>
              <p className="text-gray-300 leading-relaxed mt-3">
                You must not post content that is:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Illegal, hateful, sexually explicit, or discriminatory</li>
                <li>Infringing on third-party IP</li>
                <li>Misleading, fraudulent, or spammy</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white border-b border-purple-500/30 pb-2">
                8. EVENT LISTINGS AND NON-EVENTS
              </h2>
              <p className="text-gray-300 leading-relaxed">
                Organisers must ensure their event listing is truthful and accurate, honour ticketed events unless extenuating circumstances apply, and inform attendees and Slay immediately of changes.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white border-b border-purple-500/30 pb-2">
                9. CANCELLATION, REFUNDS & DISPUTES
              </h2>
              <p className="text-gray-300 leading-relaxed">
                Attendees are entitled to a refund if the event is cancelled or materially changed, the event fails to occur, or they are entitled under Australian Consumer Law. Each event's refund policy is listed on its individual event page. <strong>Slay platform and payment processing fees are non-refundable regardless of the organiser's policy.</strong>
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white border-b border-purple-500/30 pb-2">
                10. DATA, PRIVACY AND MARKETING
              </h2>
              <p className="text-gray-300 leading-relaxed">
                Use of Slay is subject to our Privacy Policy. We collect data to personalise your experience, users consent to receive transactional emails, and may opt-in to promotional communications.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white border-b border-purple-500/30 pb-2">
                11. LIABILITY
              </h2>
              <p className="text-gray-300 leading-relaxed">
                To the maximum extent permitted by law, Slay is not liable for acts or omissions of Event Organisers, event cancellations, no-shows, refunds, or injuries, damages, or losses occurring at an event.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white border-b border-purple-500/30 pb-2">
                12. SUSPENSION & TERMINATION
              </h2>
              <p className="text-gray-300 leading-relaxed">
                We may suspend or terminate your access if you breach these Terms, engage in fraudulent activity, or your event causes significant reputational harm.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white border-b border-purple-500/30 pb-2">
                13. INTELLECTUAL PROPERTY
              </h2>
              <p className="text-gray-300 leading-relaxed">
                All platform content, code, branding, trademarks, and software are owned or licensed by Slay. User-uploaded content remains the property of the user, but you grant us a licence to use it in connection with the services.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white border-b border-purple-500/30 pb-2">
                14. INTERNATIONAL USERS
              </h2>
              <p className="text-gray-300 leading-relaxed">
                While Slay is based in Australia, we operate globally. By using our services, you consent to the processing of data in accordance with Australian law.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white border-b border-purple-500/30 pb-2">
                15. JURISDICTION
              </h2>
              <p className="text-gray-300 leading-relaxed">
                These Terms are governed by the laws of the State of Victoria, Australia. All disputes must be resolved in the courts of Victoria.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white border-b border-purple-500/30 pb-2">
                16. CONTACT
              </h2>
              <p className="text-gray-300 leading-relaxed">
                For support, legal questions, or complaints:
              </p>
              <div className="bg-black/30 rounded-lg p-4 border border-purple-500/20">
                <p className="text-white">Email: <a href="mailto:support@slay.events" className="text-purple-400 hover:text-purple-300">support@slay.events</a></p>
                <p className="text-white">Address: Level 7, 222 Exhibition Street, Melbourne VIC 3000, Australia</p>
              </div>
              <p className="text-gray-300 leading-relaxed mt-4 italic">
                Thank you for using Slay. We're proud to serve the global LGBTQIA+ community one fabulous event at a time.
              </p>
            </section>

            <div className="text-center pt-8 border-t border-purple-500/30">
              <p className="text-gray-400">Effective Date: 22nd September 2025</p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>;
};
export default TermsOfService;